/* Destinations used by the /enterprise pages (v0 serves them under /rentid-enterprise). */
export const ENTERPRISE_LINKS = {
  home: "/enterprise",
  getStarted: "/enterprise/get-started",
  login: "/enterprise/login",
  contactEmail: "enterprise@rentid.io",
};
